import { render, staticRenderFns } from "./GAutoComplete.vue?vue&type=template&id=23472070&"
import script from "./GAutoComplete.vue?vue&type=script&lang=js&"
export * from "./GAutoComplete.vue?vue&type=script&lang=js&"
import style0 from "./GAutoComplete.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports